<template>
  <div class="container">
    <h1>Export</h1>
  </div>
</template>

<script>
import { exportDB } from "dexie-export-import";

export default {
  name: "ExportDB",
  data() {
    return {
      // Add your data properties here
    };
  },
  methods: {
    // Add your methods here
    async exportDB() {
      const db = this.$db;

      const blob = await exportDB(db, { prettyJson: true });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "db.json";
      a.click();
    },
  },
  mounted() {
    // Add your mounted hook logic here
    this.exportDB();
  },
};
</script>

<style scoped>
/* Add your component styles here */
</style>
